import { PERMISSION_RESOURCE_CODES as R } from '../../src/permissions/definitions';
import type { AppRoute } from '../routes';

const boundary = '@/modules/zy-hr/EmployeeDomainBoundary';
const base = '/payroll-center';
const page = (
  suffix: string,
  name: string,
  resource: string,
  component: string,
  icon?: string,
): AppRoute => ({
  path: `${base}${suffix}`,
  name,
  icon,
  permissionResourceCode: resource,
  component: `./zy-hr/${component}`,
});
const detail = (
  suffix: string,
  resource: string,
  component: string,
  parent: string,
): AppRoute => ({
  ...page(suffix, '', resource, component),
  hideInMenu: true,
  parentKeys: [base, `${base}${parent}`],
});

export const payrollRoutes: AppRoute[] = [
  {
    path: base,
    name: '薪酬中心',
    icon: 'wallet',
    wrappers: [boundary],
    routes: [
      {
        path: `${base}/`,
        hideInMenu: true,
        component: './Platform/OverviewRedirect',
      },
      page(
        '/overview',
        '概览',
        R.payrollWorkbench,
        'PayrollWorkbench',
        'dashboard',
      ),
      page(
        '/approval',
        '我的审批',
        R.payrollApproval,
        'ApprovalCenter',
        'audit',
      ),
      {
        path: '',
        key: 'payroll-calculation',
        name: '工资发放',
        icon: 'calculator',
        routes: [
          page('/runs', '工资核算', R.payrollRuns, 'PayrollRunList'),
          detail('/runs/:uuid', R.payrollRuns, 'PayrollRunDetail', '/runs'),
          page('/slips', '工资条管理', R.payrollSlips, 'PayrollSlipList'),
        ],
      },
      {
        path: '',
        key: 'payroll-management',
        name: '薪资管理',
        icon: 'user',
        routes: [
          page(
            '/profiles',
            '员工薪资档案',
            R.payrollProfiles,
            'EmployeePayrollProfileList',
          ),
          page(
            '/adjustments',
            '调薪管理',
            R.payrollAdjustments,
            'SalaryAdjustmentList',
          ),
        ],
      },
      {
        path: '',
        key: 'payroll-data',
        name: '月度数据',
        icon: 'database',
        routes: [
          page('/inputs', '薪资增减项', R.payrollInputs, 'PayrollInputList'),
          page(
            '/deductions',
            '月度扣缴',
            R.payrollDeductions,
            'PayrollExternalDeductionList',
          ),
          page(
            '/source-batches',
            '数据导入记录',
            R.payrollSourceBatches,
            'PayrollSourceBatchList',
          ),
        ],
      },
      {
        path: '',
        key: 'payroll-analysis',
        name: '薪酬分析',
        icon: 'barChart',
        routes: [
          page(
            '/tax-simulation',
            '个税核对',
            R.payrollTaxSimulation,
            'PayrollTaxSimulationList',
          ),
          page(
            '/cost-allocation',
            '薪酬成本分摊',
            R.payrollCostAllocation,
            'PayrollCostAllocationList',
          ),
          page(
            '/adjustment-analysis',
            '调薪分析',
            R.payrollAdjustmentAnalysis,
            'SalaryAdjustmentAnalysisList',
          ),
        ],
      },
      {
        ...page(
          '/team-summary',
          '团队薪酬汇总',
          R.payrollTeamSummary,
          'PayrollTeamSummary',
        ),
        hideInMenu: true,
      },
      page(
        '/audits',
        '操作记录',
        R.payrollAudits,
        'PayrollAuditList',
        'history',
      ),
      {
        path: '',
        key: 'payroll-settings',
        name: '薪酬设置',
        icon: 'setting',
        routes: [
          page('/plans', '薪资方案', R.payrollPlans, 'PayrollPlanList'),
          page('/items', '薪资项目', R.payrollItems, 'PayrollItemList'),
          page(
            '/workflow-settings',
            '审批流程设置',
            R.payrollWorkflowSettings,
            'PayrollWorkflowSettings',
          ),
        ],
      },
    ],
  },
];
